export default "Process AG Copropriété — Voter vos travaux de rénovation énergétique | Solution Éco France";
